import Group from 'components/utils/Group'
import LinePlaneDepartureIcon from 'LuxKit/Icons/line/LinePlaneDepartureIcon'
import Label from 'LuxKit/Label'
import BodyText from 'LuxKit/Typography/BodyText'

interface Props {
  specialOfferLabel: string
  fnfInventoryMessage: string
}

function MaldivesFnfSpecialOffer({
  specialOfferLabel,
  fnfInventoryMessage,
}: Props) {
  return (
    <Group direction="vertical" horizontalAlign="center" verticalAlign="center" gap={4}>
      <Label kind="primary" variant="highlight" format="propercase">
        {specialOfferLabel}
      </Label>
      {fnfInventoryMessage !== '' && (
        <Group direction="horizontal" horizontalAlign="center" verticalAlign="center" gap={4}>
          <LinePlaneDepartureIcon size="XS" colour="neutral-two" />
          <BodyText variant="small" colour="neutral-two">
            {fnfInventoryMessage}
          </BodyText>
        </Group>
      )}
    </Group>
  )
}

export default MaldivesFnfSpecialOffer
